import React, { Component, Fragment } from 'react'
import { prUrl } from './config.js'
import { Card, Typography, Image,  Button, Row, Col, Divider, Switch } from 'antd'
import { TwitterOutlined } from '@ant-design/icons';
import { translate } from '../utils'

const { Title, Paragraph } = Typography;

export class Tweets extends Component {
    render = () =>
        this.props.tweets ?
            this.props.tweets.map((tweet) => {
                return (
                    <TweetCard tweet={tweet} key={tweet.id}/>
                )
            })
            : ''
}

export class InnerTweets extends Component {
    state = {
        title: '',
        tweets: [],
    }

    setData = (title, tweets) => {
        this.setState({ title, tweets })
    }

    render = () =>
        this.state.tweets ?
            <Fragment>
                <Divider orientation="left" ><Title align="left" level={5} style={{ color: 'white' }}>{this.state.title}</Title></Divider>
                {this.state.tweets.map((tweet, index) => {
                    return (
                        <TweetCard tweet={tweet} key={tweet.id}/>
                    )
                })}
            </Fragment>
            : ''
}

class TweetCard extends Component {
    state = {transed: false, loading: false, transText: ''}
    setTransResult = (t)=>{
        this.setState({transText:t, transed:true, loading:false})
    }

    trans =()=>{
        if (!this.state.transed){
            this.setState({loading:true})
            translate(this.props.tweet.text, this.setTransResult)
        }else{
            this.setState({transed:false, loading:false})
        }        
    }

    render(){
        const {tweet} = this.props
        return(
            <Card title={<Title level={5}><Button type="text" icon={<TwitterOutlined frameBorder={false} />} /><a href={"https://twitter.com/" + tweet.screenName} target='blank'>{tweet.userName}</a>
                <label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{tweet.created_at.split(".")[0].replace("T", " ")}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                <Switch checkedChildren="中" unCheckedChildren="英" checked={this.state.transed} loading={this.state.loading } onClick={this.trans} size={'small'}/></Title>} size="small" align='left'>
                {tweet.encryptedImages ?
                    <Row align='middle' justify='center'>
                        <Col span={8}>
                            <Paragraph style={{ color: "white" }}>
                                {this.state.transed ? this.state.transText:tweet.text}{tweet.encryptedLink ? <a href={prUrl + tweet.encryptedLink} target='blank'>&nbsp;&nbsp;&nbsp;详情链接</a> : ""}
                            </Paragraph>
                        </Col>
                        <Col span={15}>
                        <Row align='middle' justify='left'>
                            {tweet.encryptedImages ? tweet.encryptedImages.split("||").map((image) =>
                                <Col span={Math.floor(24 / tweet.encryptedImages.split("||").length - 1) > 7 ? 7 : Math.floor(24 / tweet.encryptedImages.split("||").length - 1)} offset={1}>
                                    <Image src={prUrl + image} />
                                </Col>
                            ) : ""}
                        </Row>
                    </Col>
                    </Row> :
                    <Paragraph style={{ color: "white" }}>
                        {this.state.transed ? this.state.transText:tweet.text}{tweet.encryptedLink ? <a href={prUrl + tweet.encryptedLink} target='blank'>&nbsp;&nbsp;&nbsp;详情链接</a> : ""}
                    </Paragraph>
                }
            </Card>
        )
    }
}

export class SatImgTweets extends Component {
    render = () =>
        this.props.twimages ?
            this.props.twimages.map((tweet) => {
                return (
                    <SatImgTweetCard tweet={tweet} key={tweet.id}/>
                )
            })
            : ''
}

class SatImgTweetCard extends Component {
    state = {transed: false, loading: false, transText: ''}
    setTransResult = (t)=>{
        this.setState({transText:t, transed:true, loading:false})
    }

    trans =()=>{
        if (!this.state.transed){
            this.setState({loading:true})
            translate(this.props.tweet.text.split("http")[0], this.setTransResult)
        }else{
            this.setState({transed:false, loading:false})
        }        
    }

    render(){
        const {tweet} = this.props
        return(
            <Card title={<Title level={5}>{tweet.create_at.replace("T","  ").replace("Z","")}&nbsp;&nbsp;&nbsp;
                <Switch checkedChildren="中" unCheckedChildren="英" checked={this.state.transed} loading={this.state.loading } onClick={this.trans} size={'small'}/></Title>} size="small" align='left' style={{width:'65vw'}}>
                {tweet.images ?
                    <Row align='middle' justify='center'>
                        <Col span={8}>
                            <Paragraph style={{ color: "white" }}>{this.state.transed ? this.state.transText:tweet.text.split("http")[0]}</Paragraph>
                        </Col>
                        <Col span={15}>
                            <Row align='middle' justify='left'>
                                {tweet.images ? tweet.images.split("||").map((image) =>
                                    <Col span={Math.floor(24 / tweet.images.split("||").length - 1) > 7 ? 7 : Math.floor(24 / tweet.images.split("||").length - 1)} offset={1}>
                                        <Image src={prUrl + image} />
                                    </Col>
                                ) : ""}
                            </Row>
                        </Col>
                    </Row> :
                    <Paragraph style={{ color: "white" }}>
                        {this.state.transed ? this.state.transText:tweet.text.split("http")[0]}
                    </Paragraph>
                }
            </Card>
        )
    }
}